import classnames from 'classnames';
import { FunctionComponent } from 'react';

type InfoCircleFilledProps = {
    className?: string;
};

const InfoCircleFilled: FunctionComponent<InfoCircleFilledProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'info-circle-filled'}
            viewBox="0 0 250 250"
        >
            <path
                d="M125.7.5C57.1.5 1.2 56.4 1.2 125s55.9 124.5 124.5 124.5S250.2 193.6 250.2 125 194.4.5 125.7.5zm14 50.7c-3.3 0-6.1 1.3-8.4 3.9-2.4 2.6-3.6 5.7-3.6 9.2 0 3.3 1.2 6.3 3.6 8.9 2.4 2.6 5.2 3.9 8.4 3.9 3.5 0 6.5-1.4 8.8-4.1 2.4-2.7 3.6-5.9 3.6-9.6 0-3.3-1.2-6.1-3.5-8.6-2.3-2.3-5.3-3.6-8.9-3.6zm-4.9 136.7c-3.6 0-6.3-.7-7.9-2-1.6-1.3-2.4-3.8-2.4-7.5 0-1.5.2-3.5.7-5.9.5-2.4 1-4.9 1.7-7.4l10.2-40.8c.5-2 .9-4 1.2-6 .3-2 .4-3.6.4-4.7 0-4.2-1.2-7.6-3.6-10.1-2.4-2.5-6.2-3.7-11.4-3.7-2.3 0-5.4.5-9.4 1.6s-8.4 2.8-13.4 5l-1.4 6.1c1.2-.3 3-.7 5.3-1.2 2.3-.4 4.2-.7 5.6-.7 3.6 0 6.1.6 7.2 1.8 1.2 1.2 1.8 3.6 1.8 7.2 0 1.8-.2 4-.7 6.5-.5 2.6-1 5-1.5 7.2l-10.1 40.8c-.6 2.4-1 4.5-1.2 6.1-.3 1.6-.4 3.1-.4 4.6 0 3.9 1.3 7.2 3.8 9.8 2.6 2.7 6.4 4 11.5 4 2.5 0 5.5-.5 9-1.4 3.5-.9 8.2-2.6 14.1-4.9l1.4-6.1c-1.2.4-3 .8-5.2 1.2-2.3.4-4.1.5-5.3.5z"
                fillRule="evenodd"
            />
        </svg>
    );
};
export default InfoCircleFilled;
